import { Action } from 'redux';

import { DraftsTelemetry } from '~src/drafts/telemetry/DraftsTelemetry';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { EditView } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface EditViewAction extends Action {
  view: IContentInfo;
  draftOrigin?: DraftsTelemetry.LocationOrigin;
}

export function editView(view: IContentInfo): EditViewAction {
  return {
    type: EditView,
    view
  };
}

export function editViewDraft(view: IContentInfo, draftOrigin: DraftsTelemetry.LocationOrigin): EditViewAction {
  return {
    type: EditView,
    view,
    draftOrigin
  };
}

export const isEditViewAction = isActionFactory<EditViewAction>(EditView);
